import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalserviceService } from '../globalservice.service';


@Component({
  selector: 'app-disable',
  templateUrl: './disable.component.html',
  styleUrls: ['./disable.component.css']
})
export class DisableComponent implements OnInit {
  disable = [];
  base_url = this.globalservice.base_url;
  constructor(public dialogRef: MatDialogRef<DisableComponent>, public globalservice: GlobalserviceService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }
  Diable_Fn() {
    var data = {
      "DeviceNumber": sessionStorage.deviceid,
      "Emp_ID": sessionStorage.employeid,
      "Active": "0"
    }
    debugger;
    this.globalservice.enableloader();
    this.globalservice.EnableDis(data).subscribe(responsedata => {
      debugger;
      this.globalservice.disableloader();
      if (responsedata.Success) {
        this.disable = responsedata['Data'];
        this.dialogRef.close();
      }
      else {
      }
    },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });
  }

  no_fun() {
    window.location.reload();
  }


}
